import { render, staticRenderFns } from "./privacyPage.vue?vue&type=template&id=5daa68c8&"
import script from "./privacyPage.vue?vue&type=script&lang=js&"
export * from "./privacyPage.vue?vue&type=script&lang=js&"
import style0 from "./privacyPage.vue?vue&type=style&index=0&id=5daa68c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports